<template>
  <div id="app">
    <div
      v-if="!showRouter && !bdShow && !ezShow"
      :key="key"
      style="background-color: #ededed"
    >
      <iframe
        ref="iframe"
        :src="homeSrc"
        frameborder="0"
        style="width: 100%; height: 99vh"
      ></iframe>
    </div>
    <div v-if="!showRouter && bdShow" :key="key" style="background-color: #ededed">
      <link rel="stylesheet" href="./static/files/init.css" />
      <link rel="stylesheet" href="./static/files/index.css" />
      <link
        rel="shortcut icon"
        href="http://www.ezbeidou.com/assets/img/indeximg/ezlogo.png"
      />
      <div class="indexBg">
        <div class="index_container">
          <div class="header flex">
            <!-- <img
              src="./static/files/cqllogo.png"
              alt=""
              style="width: 140px; height: 35px"
            /> -->
            <div>欢迎访问嘉祥博达电子科技有限公司</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="index_container">
          <div class="name">专注交通安全</div>
          <div class="name2">致力车联网解决方案提供商</div>
          <div class="rootList flex">
            <a class="block block1" href="https://safe.ezbeidou.com/" style="color: #333">
              <div class="img" style="width: 60px; height: 60px"></div>
              <div>安全培训</div>
            </a>
            <a
              class="block block2"
              style="color: #333"
              href="https://safe.ezbeidou.com/index/index/subjecttype/type/2.html"
            >
              <div class="img" style="width: 70px; height: 60px"></div>
              <div>在线继续教育</div>
            </a>
            <a class="block block3" style="color: #333" @click="router">
              <div class="img" style="width: 65px; height: 60px"></div>
              <div>视频监控管理系统</div>
            </a>
            <a class="block block4" style="color: #333">
              <div class="img" style="width: 60px; height: 60px"></div>
              <div>行业监管</div>
            </a>
          </div>
        </div>
      </div>
      <div class="index_container con">
        <!-- <div class="title" style="margin-top: 4vh; margin-bottom: 2vh">
          关于我们
        </div> -->
        <div class="flex changeName">
          <!-- <div
            :class="[active ? 'active' : '']"
            data-id="0"
            @click="changeMain(0)"
          >
            公司简介
          </div> -->
          <!-- <div
            :class="[!active == false ? '' : 'active']"
            data-id="1"
            @click="changeMain(1)"
          >
            发展历程
          </div> -->
        </div>
        <!-- <div class="cont cont1" v-if="showmain">
          <div class="flex">
            <img src="./static/files/jianjieImg.png" alt="" />
            <div class="contText">
              山东易车联电子科技有限公司成立于2015年7月，位
              于烟台市芝罘区东和科技园，注册资金1000万，是一家多
              元化高科技创新型企业，主要服务于交通、环保、公安行
              业，主营范围涵盖车载物联网、北斗定位、信息系统智能
              化，软件开发与服务，计算机系统集成，人工智能等多个
              方面。本着以北斗卫星定位为基础，以智能位置信息为依
              托，“大数据、大平台、大服务”的品牌战略。
            </div>
          </div>
          <div class="flex">
            <div class="contText">
              致力于北斗独立的智能应用，拥有独立的北斗应用研发技
              术团队和完善的售后服务体系，能为用户量身定制最科学全面
              的北斗应用产品以及提供优质的用户体验。目前运营的道路货
              运车辆监管平台服务山东省超10万台车，为上千家物流公司提
              供专业车队服务，为山东省多个地市监管平台提供成熟完善的
              解决方案，为多家上市企业提供大数据定制服务。
            </div>
            <img src="./static/files/lichengImg.png" alt="" />
          </div>
        </div>
        <div class="cont cont2 flex" v-else>
          <div style="margin-top: 140px">
            <div class="contTitle">2015-2016</div>
            <div>
              顺应北斗军用改民用政策, 切入货运市场,迅速在山东
              省重要城市：德州、菏泽、 济宁、临沂、青岛、潍坊、
              淄博,济南设立经销商。
            </div>
          </div>
          <div style="margin-top: 20px">
            <div class="contTitle">2017-2018</div>
            <div>
              系统累积接入车辆数据超一万台自主研发“物流企业
              综合管理平台”、“汽车尾 气监控平台”并切入山东
              省货运车辆尾气改造项目。
            </div>
          </div>
          <div style="margin-top: -80px">
            <div class="contTitle">2019-2022</div>
            <div>
              “易智车联北斗服务平台”"易智车联安全培训一体化管理系统“扬帆起航，充分利用互联网，大数据，人工智能等技术，为物流物联网的建设及各行业的信息化提供支持。
            </div>
          </div>
          <div style="margin-top: -180px">
            <div class="contTitle">2022-未来</div>
            <div>
              响应”十四五“规划，在” 交通强国“战略和《国家综
              合立体交通网规划纲要》等 大方针的引领下，夯实技术
              为交通行业添砖加瓦。
            </div>
          </div>
        </div> -->
      </div>
      <div class="app_footer">
        <ul>
          <li style="margin-right: 150px">
            <div class="footer_li_title">联系我们</div>
            <div class="info">
              <span>联系电话:</span>
              <p>13153783563 / 赵经理</p>
            </div>
            <div class="info">
              <span>售后电话:</span>
              <p>0537-6696552</p>
            </div>
            <div class="info">
              <span>邮箱:</span>
              <p>jxbddzkjyxgs@163.com</p>
            </div>
            <div class="info">
              <span>地址:</span>
              <p>山东省济宁市嘉祥县鲜农都小区7号楼728室</p>
            </div>
          </li>
          <!--
          <li>
            <div class="footer_li_title">导航</div>
            <p>易管车</p>
            <p>易学习</p>
            <p>易加油</p>
            <p>易保险</p>
            <p>ETC</p>
          </li> -->

          <li>
            <div class="footer_li_title">解决方案</div>
            <div class="scheme">
              <div>
                <img src="./static/files/bottom1.png" alt="" />
                <p>网约车车载终端</p>
              </div>
              <div>
                <img src="./static/files/bottom2.png" alt="" />
                <p>物流车队管理服务</p>
              </div>
              <div>
                <img src="./static/files/bottom3.png" alt="" />
                <p>第三方监控管理服务</p>
              </div>
              <div>
                <img src="./static/files/bottom4.png" alt="" />
                <p>渣土车智慧管理服务</p>
              </div>
            </div>
          </li>

          <!--<li>-->
          <!--  <img src="/assets/img/login/And.png" alt=""><br>-->
          <!--  <span>浏览器扫码下载</span><br>-->
          <!--</li>-->
        </ul>

        <div>
          <span
            >©Copyrights 2016 <span style="color: red">Template_path</span>. All rights
            reserved</span
          >
          <a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2022010114号-1</a>
          <a href="#">
            <img class="fly" src="./static/files/fly.png" alt="" />
          </a>
        </div>
      </div>
    </div>
    <!-- ez北斗 -->
    <div v-if="!showRouter && ezShow" :key="key" style="background-color: #ededed">
      <!--      <link rel="stylesheet" href="./static/files/init.css" />-->
      <!--      <link rel="stylesheet" href="./static/files/index.css" />-->
      <link
        rel="shortcut icon"
        href="http://www.ezbeidou.com/assets/img/indeximg/ezlogo.png"
      />
      <div class="indexBg">
        <div class="index_container">
          <div class="header flex">
            <img
              src="./static/files/yzlogo.jpeg"
              alt=""
              style="width: 35px; height: 35px"
            />
            <div>山东屹振网络科技有限公司</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="index_container">
          <div class="name">专注交通安全</div>
          <div class="name2">致力车联网解决方案提供商</div>
          <div class="rootList flex">
            <a class="block block1" href="https://safe.ezbeidou.com/" style="color: #333">
              <div class="img" style="width: 60px; height: 60px"></div>
              <div>安全培训</div>
            </a>
            <a
              class="block block2"
              style="color: #333"
              href="https://safe.ezbeidou.com/index/index/subjecttype/type/2.html"
            >
              <div class="img" style="width: 70px; height: 60px"></div>
              <div>在线继续教育</div>
            </a>
            <a class="block block3" style="color: #333" @click="router">
              <div class="img" style="width: 65px; height: 60px"></div>
              <div>视频监控管理系统</div>
            </a>
            <a
              class="block block4"
              style="color: #333"
              href="http://superior.ezbeidou.com/login.html"
            >
              <div class="img" style="width: 60px; height: 60px"></div>
              <div>行业监管</div>
            </a>
          </div>
        </div>
      </div>
      <div class="index_container con">
        <div class="title" style="margin-top: 4vh; margin-bottom: 2vh">关于我们</div>
        <div class="flex changeName">
          <div :class="[active ? 'active' : '']" data-id="0" @click="changeMain(0)">
            公司简介
          </div>
          <div
            :class="[!active == false ? '' : 'active']"
            data-id="1"
            @click="changeMain(1)"
          >
            发展历程
          </div>
        </div>
        <div class="cont cont1" v-if="showmain">
          <div class="flex">
            <img src="./static/files/jianjieImg.png" alt="" />
            <div class="contText">
              山东屹振网络科技有限公司成立于2015年7月，位于聊城东昌府区，注册资金300万，是一家多元化高科技创型企业，主要服务于交通、环保、公安行
              业，主营范围涵盖车北斗定位、信息系统智能
              化，软件联网系统集成，人工智能等多个方面。本着以北斗卫星定位为基础以智能位置信息为依托，“大数据、大平台、大服务”的品牌战略。
            </div>
          </div>
          <div class="flex">
            <div class="contText">
              致力于北斗独立的智能应用，拥有独立的北斗应用研发技术团队和完善的售后服务体系，能为用户量身定制最科学全面的北斗应用产品以及提供优质的用户体验。目前运营的道路货
              运车辆监平台服务山东省超10万台车，为上千家物流服务公司提供专业的车队服务，为山东省多个地市监管平台提供成熟完善的解决方案，为多家上市公司提供大数据定制服务。
            </div>
            <img src="./static/files/lichengImg.png" alt="" />
          </div>
        </div>
        <div class="cont cont2 flex" v-else>
          <div style="margin-top: 140px">
            <div class="contTitle">2015-2016</div>
            <div>
              顺应北斗军用改民用政策, 切入货运市场,迅速在山东 省重要城市：德州、菏泽、
              济宁、临沂、青岛、潍坊、 淄博,济南设立经销商。
            </div>
          </div>
          <div style="margin-top: 20px">
            <div class="contTitle">2017-2018</div>
            <div>
              系统累积接入车辆数据超一万台自主研发“物流企业 综合管理平台”、“汽车尾
              气监控平台”并切入山东 省货运车辆尾气改造项目。
            </div>
          </div>
          <div style="margin-top: -80px">
            <div class="contTitle">2019-2022</div>
            <div>
              “易智车联北斗服务平台”"易智车联安全培训一体化管理系统“扬帆起航，充分利用互联网，大数据，人工智能等技术，为物流物联网的建设及各行业的信息化提供支持。
            </div>
          </div>
          <div style="margin-top: -180px">
            <div class="contTitle">2022-未来</div>
            <div>
              响应”十四五“规划，在” 交通强国“战略和《国家综 合立体交通网规划纲要》等
              大方针的引领下，夯实技术 为交通行业添砖加瓦。
            </div>
          </div>
        </div>
      </div>
      <div class="app_footer">
        <ul>
          <li style="margin-right: 150px">
            <div class="footer_li_title">联系我们</div>
            <div class="info">
              <span>联系电话:</span>
              <p>0635-8906895 / 座机客服</p>
            </div>
            <div class="info">
              <span>售后电话:</span>
              <p>15063590005 / 徐经理</p>
            </div>
            <div class="info">
              <span>邮箱:</span>
              <p>1064556537@qq.com</p>
            </div>
            <div class="info">
              <span>地址:</span>
              <p>山东省聊城市东昌府区芳苑小区门口东30米</p>
            </div>
          </li>
          <!--
          <li>
            <div class="footer_li_title">导航</div>
            <p>易管车</p>
            <p>易学习</p>
            <p>易加油</p>
            <p>易保险</p>
            <p>ETC</p>
          </li> -->

          <li>
            <div class="footer_li_title">解决方案</div>
            <div class="scheme">
              <div>
                <img src="./static/files/bottom1.png" alt="" />
                <p>网约车车载终端</p>
              </div>
              <div>
                <img src="./static/files/bottom2.png" alt="" />
                <p>物流车队管理服务</p>
              </div>
              <div>
                <img src="./static/files/bottom3.png" alt="" />
                <p>第三方监控管理服务</p>
              </div>
              <div>
                <img src="./static/files/bottom4.png" alt="" />
                <p>渣土车智慧管理服务</p>
              </div>
            </div>
          </li>

          <!--<li>-->
          <!--  <img src="/assets/img/login/And.png" alt=""><br>-->
          <!--  <span>浏览器扫码下载</span><br>-->
          <!--</li>-->
        </ul>

        <div>
          <span
            >©Copyrights 2016 <span style="color: red">Template_path</span>. All rights
            reserved</span
          >
          <span>鲁ICP备18056593号-2</span>
          <a href="#">
            <img class="fly" src="./static/files/fly.png" alt="" />
          </a>
        </div>
      </div>
    </div>

    <router-view v-if="showRouter" :key="key" />
  </div>
</template>

<script>
import { createSocket } from "./utils/websocket";
import Cookies from "js-cookie";
import { getToken } from "@/utils/auth";
export default {
  name: "App",
  metaInfo() {
    return {
      title: this.$store.state.settings.dynamicTitle && this.$store.state.settings.title,
      titleTemplate: (title) => {
        return title
          ? `${title} - ${process.env.VUE_APP_TITLE}`
          : process.env.VUE_APP_TITLE;
      },
    };
  },
  created() {
    console.log("process.env:", process.env);
    let url = window.location.href;
    url = url.replace("://", "");
    const hostname = window.location.hostname
    console.log(url, hostname);
    if (hostname === 'www.dzbeidou.com') {
      this.homeSrc = 'dzhome/index.html'
      this.showRouter = false
      this.key++
    } else if (-1 !== url.indexOf("bdbeidou")) {
      // this.showRouter = true;
      // this.key++;
      this.bdShow = true;
      Cookies.set("SystemTitle", "博达电子运营平台");
    } else if (-1 !== url.indexOf("yizhen") ||  -1 !== url.indexOf("117.78.16.18")) {
      this.ezShow = true;
      Cookies.set("SystemLogo", "yzlogo");
      Cookies.set("SystemTitle", "屹振网络科技有限公司");
    } else {
      if (-1 !== url.indexOf("/login") || url.length === url.indexOf("/") + 1) {
        // console.log("111");
        this.showRouter = false;
        this.key++;
      } else {
        // console.log("222");
        this.showRouter = true;
        this.key++;
      }
      // this.ezShow = true;
    }

    console.log("调试输出：",url, this.ezShow, this.bdShow,this.showRouter);
  },
  mounted() {
    window.addEventListener("message", this.handleMessage);
    if (this.$refs.iframe) {
      this.$refs.iframe.allow = 'microphone *;camera *'
    }
  },
  data() {
    return {
      key: 0,
      homeSrc: 'homev2/index.html',
      showRouter: false,
      showmain: true,
      active: true,
      bdShow: false,
      ezShow: false,
    };
  },

  methods: {
    handleMessage(event) {
      // 获取从iframe页面中传过来的值
      if (event.data.params === '0') {
        this.showRouter = true;
      }
    },
    router() {
      this.showRouter = true;
    },
    changeMain(e) {
      if (e == 0) {
        this.showmain = true;
        this.active = true;
        return;
      }
      if (e == 1) {
        this.showmain = false;
        this.active = false;
        return;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/app.scss";
</style>
<style lang="scss" scoped>
@import "static/files/index.css";
@import "static/files/init.css";

// #app {
//   width: 100vw;
//   height: 100vh;
//   background-color: #020308;
//   overflow: hidden;
// }
/* 底部 */
.app_footer {
  // height: 420px;
  padding-top: 70px;
  color: #bebfbe;
  background-color: #1b3454;
}

.app_footer ul {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #fff;
}

.app_footer li {
  height: 359px;
}

.footer_li_title {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 35px;
}

.app_footer li .info span {
  font-size: 12px;
}

.app_footer li .info p {
  margin: 10px 0 20px;
  color: #fff;
}

.app_footer li:nth-child(2) p {
  margin-bottom: 36px;
}

.app_footer .scheme {
  width: 320px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.app_footer .scheme > div p {
  margin: 5px 0 30px;
}

.app_footer li:nth-child(3) {
  margin-right: 100px;
}

.app_footer li:nth-child(4) {
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.app_footer > div {
  height: 60px;
  line-height: 60px;
  color: #fff;
  padding-left: 20%;
  padding-right: 13px;
  display: flex;
  justify-content: space-between;
}

.app_footer .fly {
  width: 32px;
  height: 32px;
  position: relative;
  top: 13px;
  cursor: pointer;
}
</style>
